export function parseSourceQuote(quote: any): PolicyQuote | TraditionalLTCQuote | null {
  if (!quote) return null;

  let parsedQuote: PolicyQuote | TraditionalLTCQuote;

  if (typeof quote === 'string') {
    try {
      parsedQuote = JSON.parse(quote);
    } catch (error) {
      console.error('Failed to parse quote JSON string:', error);
      return null;
    }
  } else if (typeof quote === 'object') {
    parsedQuote = quote;
  } else {
    return null;
  }

  if (parsedQuote.hasOwnProperty('insuranceQuoteId') || parsedQuote.hasOwnProperty('traditionalLTCQuoteId')) {
    return parsedQuote as PolicyQuote | TraditionalLTCQuote;
  }

  console.error('Quote missing required ID fields:', parsedQuote);
  return null;
}

export function getQuoteId(quote: PolicyQuote | TraditionalLTCQuote | null): string | null {
  if (!quote) return null;

  return quote.hasOwnProperty('traditionalLTCQuoteId')
    ? (quote as TraditionalLTCQuote).traditionalLTCQuoteId
    : (quote as PolicyQuote).insuranceQuoteId;
}